import {
  DashboardMultiSelectDropdown,
  DashboardSelectDropdownComponent,
} from 'bd-web-components'
import { FilterContainer } from './styles'

export interface SelectorType {
  name: string
  id: number
}

interface AccessAndSalesFiltersProps {
  isMobile: boolean
  comissarios: SelectorType
  setComissarios: (value: SelectorType) => void
  ocasioes: SelectorType
  setOcasioes: (value: SelectorType) => void
  selectedSectors: number[]
  setSelectedSectors: (value: number[]) => void
  formattedPdvs: {
    pdvs: SelectorType[]
    ocasioes: SelectorType[]
  }
}

export function AccessAndSalesFilters({
  isMobile,
  comissarios,
  setComissarios,
  ocasioes,
  setOcasioes,
  selectedSectors,
  setSelectedSectors,
  formattedPdvs,
}: AccessAndSalesFiltersProps) {
  const ocasioesList = formattedPdvs.ocasioes.map((item) => ({
    name: item.name,
    id: item.id,
  }))
  const ocasioesDefault = ocasioesList[0] ?? { name: 'Entrada', id: 0 }

  return (
    <FilterContainer>
      <DashboardSelectDropdownComponent
        title={'Comissários'}
        data={[{ name: 'Não', id: 1 }]}
        defaultItem={{ name: 'Sim', id: 0 }}
        numberWidth={isMobile ? '100%' : 250}
        setSelectedItem={setComissarios}
        selectedValue={comissarios}
      />

      <DashboardSelectDropdownComponent
        title={'Ocasiões'}
        data={ocasioesList.slice(1)}
        defaultItem={ocasioesDefault}
        numberWidth={isMobile ? '100%' : 250}
        setSelectedItem={setOcasioes}
        selectedValue={ocasioes}
      />
      <div
        style={{
          marginBottom: '15px',
        }}
      >
        <DashboardMultiSelectDropdown
          title={'Pontos de Venda'}
          data={formattedPdvs.pdvs}
          defaultItem={{ name: 'Todos', id: 0 }}
          numberWidth={isMobile ? '100%' : 330}
          selectedSectors={selectedSectors}
          setSelectedSectors={setSelectedSectors}
        />
      </div>
    </FilterContainer>
  )
}
